export default "__VITE_ASSET__810d9014__"